import React, { useEffect, useState, forwardRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./component.scss";
import { useSelector } from "react-redux";

const StatusCustomReport = forwardRef((props, ref) => {
  let ledgerFilters = useSelector(
    (state) => state.customer.ledgers.ledgersFilter
  );
  const ledgersSteps = useSelector((state) => state.customer.ledgers.step);
 
  const [getStockData, setStockData] = useState(props?.ldgerName);
  const [getledgersData, setledgersData] = useState(props?.getledgersData);



  useEffect(() => {
    // setStep(props?.step);
    // setData(props?.formInputs);
    setStockData(props?.getStockDaylyData);
    setledgersData(props?.getledgersData);
  }, [props]);

  let totalPoInwardNetValue = 0;
  let totalPoInwardQty = 0;
  let totalPoInvBasicAmount = 0;
  let totalPoOutwardQty = 0;

  let totalRoundOff = 0;

  let totalSalescgstValue14 = 0;
  let totalSalesSgstValue14 = 0;
  let totalSalesSgstValue9 = 0;
  let totalSalesCgstValue9 = 0;

  let totalPocgstValue14 = 0;
  let totalPoSgstValue14 = 0;
  let totalPoSgstValue9 = 0;
  let totalPoCgstValue9 = 0;

  getStockData &&
    getStockData.forEach((item) => {
      totalPoInwardNetValue += item.poInwardNetValue || 0;
      totalPoInwardQty += item.poInwardQty || 0;
      totalPoInvBasicAmount += item.poInvBasicAmount || 0;
      totalPoOutwardQty += item.poOutwardQty || 0;
    });

  getledgersData &&
    getledgersData.forEach((item) => {
      totalRoundOff += item?.roundOff || 0;
      totalSalescgstValue14 += item?.cgstValue_14 || 0;
      totalSalesSgstValue14 += item?.sgstValue_14 || 0;
      totalSalesSgstValue9 += item?.sgstValue_9 || 0;
      totalSalesCgstValue9 += item?.cgstValue_9 || 0;

      totalPocgstValue14 += item?.poCgstValue_14 || 0;
      totalPoSgstValue14 += item?.poSgstValue_14 || 0;
      totalPoSgstValue9 += item?.poSgstValue_9 || 0;
      totalPoCgstValue9 += item?.poCgstValue_9 || 0;
    });


  return (
    <div ref={ref}>
      <form className="">
        {ledgersSteps && (
          <Row>
            <Col xs={12} md={12} lg={12} className="">
              <div className="card mb-0">
                <div className="card-body statusCountScroll">
                  <>
                    {ledgersSteps > 1 &&
                      ledgerFilters[0]?.ledgersQuerName !== "Customer" &&
                      ledgerFilters[0]?.description && (
                        // ledgerFilters[0]?.reportType === "CASH_BANK" &&
                        <span className="bg-table-status bg-table-success-status px-4 mr-2">
                          {ledgerFilters[0]?.description &&
                            ledgerFilters[0]?.description}
                        </span>
                      )}
                    {ledgersSteps > 2 &&
                      ledgerFilters[0]?.ledgersQuerName === "Customer" && (
                        <>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.description &&
                              ledgerFilters[0]?.description}
                          </span>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {/* {(ledgerFilters[0]?.ledgersQuerName && "Customer/Employe")} */}
                            Customer/Employee
                          </span>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            Month : {ledgerFilters[0]?.month} / Year:{" "}
                            {ledgerFilters[0]?.year}
                          </span>

                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0].customerCode} -{" "}
                            {ledgerFilters[0].customerName}{" "}
                          </span>
                        </>
                      )}

                    {ledgersSteps > 2 &&
                      ledgerFilters[0]?.reports &&
                      ledgerFilters[0]?.reportType !== "CASH_BANK" && (
                        <>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.reports &&
                              ledgerFilters[0]?.reports}
                          </span>
                          {(ledgerFilters[0]?.reportType === "SALES" ||
                            ledgerFilters[0]?.reportType === "PURCHASE") && (
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              Month : {ledgerFilters[0]?.month} / Year:{" "}
                              {ledgerFilters[0]?.year}
                            </span>
                          )}
                          {ledgersSteps === 3 &&
                            ledgerFilters[0]?.reportType === "SALES" && (
                              <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                                Total Debit :{" "}
                                {props.getToatalCalucation[0]?.totalDebitAmount}
                              </span>
                            )}
                          {ledgersSteps === 3 &&
                            ledgerFilters[0]?.reportType === "PURCHASE" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Total Credit:{" "}
                                {
                                  props.getToatalCalucation[0]
                                    ?.totalCreditAmount
                                }
                              </span>
                            )}
                        </>
                      )}
                    {ledgersSteps > 2 &&
                      ledgerFilters[0]?.reports &&
                      ledgerFilters[0]?.reportType === "EXPENSE" && (
                        <>
                          {ledgerFilters[0]?.expenseName && (
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              {ledgerFilters[0]?.expenseName &&
                                ledgerFilters[0]?.expenseName}
                            </span>
                          )}

                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            Month : {ledgerFilters[0]?.month} / Year:{" "}
                            {ledgerFilters[0]?.year}
                          </span>
                        </>
                      )}
                    {ledgersSteps > 3 && (
                      <>
                        {ledgerFilters[0]?.reportType === "STOCK" && (
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.product &&
                              ledgerFilters[0]?.product}
                          </span>
                        )}

                        {ledgerFilters[0]?.reports === "Ledger" && (
                          <>
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              {/* {(ledgerFilters[0]?.ledgers && ledgerFilters[0]?.ledgers) || ((ledgerFilters[0]?.customerCode && ledgerFilters[0]?.customerCode -(ledgerFilters[0]?.customerName && ledgerFilters[0]?.customerName)))} */}
                              {ledgerFilters[0]?.ledgers
                                ? ledgerFilters[0].ledgers
                                : ledgerFilters[0]?.customerCode &&
                                  ledgerFilters[0]?.customerName
                                ? `${ledgerFilters[0].customerCode} - ${ledgerFilters[0].customerName}`
                                : "--"}
                            </span>
                            {/* <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              {(ledgerFilters[0]?.customerName && ledgerFilters[0]?.customerName)}
                            </span> */}
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              Month : {ledgerFilters[0]?.month} / Year:{" "}
                              {ledgerFilters[0]?.year}
                            </span>
                            {ledgerFilters[0]?.ledgers === "RoundOff" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Round Of : {totalRoundOff}
                              </span>
                            )}
                            {ledgerFilters[0]?.ledgers ===
                              "Outward CGST 14%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Outward CGST 14% : {totalSalescgstValue14}
                              </span>
                            )}
                            {ledgerFilters[0]?.ledgers ===
                              "Outward SGST 14%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Outward SGST 14% : {totalSalesSgstValue14}
                              </span>
                            )}

                            {ledgerFilters[0]?.ledgers ===
                              "Outward CGST 9%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Outward CGST 9% : {totalSalesSgstValue9}
                              </span>
                            )}

                            {ledgerFilters[0]?.ledgers ===
                              "Outward SGST 9%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Outward SGST 9% : {totalSalesCgstValue9}
                              </span>
                            )}

                            {ledgerFilters[0]?.ledgers ===
                              "Inward SGST 14%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Inward SGST 14% : {totalPoSgstValue14}
                              </span>
                            )}
                            {ledgerFilters[0]?.ledgers ===
                              "Inward CGST 14%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Inward CGST 14% : {totalPocgstValue14}
                              </span>
                            )}
                            {ledgerFilters[0]?.ledgers === "Inward SGST 9%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Inward SGST 9% : {totalPoSgstValue9}
                              </span>
                            )}
                            {ledgerFilters[0]?.ledgers === "Inward CGST 9%" && (
                              <span className="bg-table-status bg-table-success-status px-4 mr-2">
                                Inward CGST 9% : {totalPoCgstValue9}
                              </span>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {ledgersSteps > 4 && (
                      <>
                        {/* {ledgerFilters[0]?.reportType === "STOCK" && (
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.product &&
                              ledgerFilters[0]?.product}
                          </span>
                        )} */}
                        {ledgerFilters[0]?.reportType === "LEDGER" && (
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.material &&
                              ledgerFilters[0]?.ledgers}
                          </span>
                        )}
                        {ledgerFilters[0]?.reportType === "CASH_BANK" && (
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            {ledgerFilters[0]?.bankName &&
                              ledgerFilters[0]?.bankName}
                          </span>
                        )}
                        <span className="bg-table-status bg-table-success-status px-4 mr-2">
                          Month : {ledgerFilters[0]?.month} / Year:{" "}
                          {ledgerFilters[0]?.years}
                        </span>
                        {ledgerFilters[0]?.reportType === "STOCK" && (
                          <>
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              Purchase Amount:{totalPoInwardNetValue}
                            </span>
                            <span className="bg-table-status bg-table-success-status px-4 mr-2">
                              Purchase Bags:{totalPoInwardQty}
                            </span>

                            <span className="bg-table-status bg-table-new-status px-4 mr-2">
                              Sales Amount:{totalPoInvBasicAmount}
                            </span>
                            <span className="bg-table-status bg-table-new-status px-4 mr-2">
                              Sales Bags:{totalPoOutwardQty}
                            </span>

                            <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                              Balance Amount:
                              {(
                                totalPoInwardNetValue - totalPoInvBasicAmount
                              ).toFixed(2)}
                            </span>
                            <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                              Balance Bags:
                              {totalPoInwardQty - totalPoOutwardQty}
                            </span>
                          </>
                        )}
                      </>
                    )}
                    {ledgersSteps === 5 &&
                      ledgerFilters[0]?.reportType === "CASH_BANK" &&
                      ledgerFilters[0]?.transactionType === "EK" && (
                        <span className="bg-table-status bg-table-success-status px-4 mr-2">
                          Total Credit :{" "}
                          {props.getToatalCalucation[0]?.totalCreditAmount}
                        </span>
                      )}
                    {ledgersSteps === 5 &&
                      ledgerFilters[0]?.reportType === "CASH_BANK" &&
                      ledgerFilters[0]?.transactionType === "BK" && (
                        <span className="bg-table-status bg-table-success-status px-4 mr-2">
                          Total Credit :{" "}
                          {props.getToatalCalucation[0]?.totalCreditAmount}
                        </span>
                      )}
                    {ledgersSteps === 3 &&
                      ledgerFilters[0]?.ledgersQuerName === "Customer" && (
                        <>
                          <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                            Total Debit :{" "}
                            {props.getToatalCalucation[0]?.totalDebitAmount ||
                              "0"}
                          </span>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            Total Debit :{" "}
                            {props.getToatalCalucation[1]?.totalCreditAmount ||
                              "0"}
                          </span>
                        </>
                      )}
                    {ledgersSteps === 4 &&
                      ledgerFilters[0]?.reportType === "EXPENSE" && (
                        <>
                          <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                            Total Debit :{" "}
                            {props.getToatalCalucation[0]?.totalDebitAmount ||
                              "0"}
                          </span>
                          <span className="bg-table-status bg-table-success-status px-4 mr-2">
                            Total Debit :{" "}
                            {props.getToatalCalucation[1]?.totalCreditAmount ||
                              "0"}
                          </span>
                        </>
                      )}
                  </>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </form>
    </div>
  );
});

export default StatusCustomReport;
